import { useCallback } from 'react'

import { ReportHistoryTemplate } from 'app/common/templates-next/report-template'
import { ReportType } from 'app/dataTypes/reports'
import { GET_DOWNLOAD_FILE } from 'app/common/api/requests/reports/download_file'
import { api } from 'app/api'

import useHistoty from './useHistory'
import { handleSendFileToEmail, handleCheckStatus } from './historyHandlers'


type Props = {
  filenameBase: string
  reportType: ReportType
}

export const History = ({ filenameBase, reportType }: Props) => {
  const { history, requestHistory, loading, setLoading } = useHistoty(reportType)

  const handleDownloadFile = useCallback(async (reportId: number) => {
    await api.download(GET_DOWNLOAD_FILE, {
      error: 'Не удалось загрузить файл',
      filename: `${filenameBase}_${reportId}`,
      params: { reportId },
    })
  }, [filenameBase])

  const handleDisplayStatusChange = useCallback((status: boolean) => {
    if (!status) {
      setLoading(true)
    }
  }, [setLoading])

  return (
    <ReportHistoryTemplate
      items={history}
      onRequestHistory={requestHistory}
      loading={loading}
      onSendFileToEmail={handleSendFileToEmail}
      onDownloadFile={handleDownloadFile}
      onCheckStatus={handleCheckStatus}
      onDisplayStatusChange={handleDisplayStatusChange}
    />
  )
}
